<template>
  <div id="for-business-page">
    <CoinsBanner :banner="'prestamo-negocios.png'" :isBusiness="true">
      <template v-slot:title>Capital de trabajo para tu negocio de impacto.</template>
    </CoinsBanner>
    <FundDestinations>
      <template v-slot:subtitle>Uso del crédito.</template>
      <template v-slot:title>Empresas que combaten el <span class="bold">cambio climático.</span></template>
    </FundDestinations>
    <LoanDetail 
      :isBusiness="true"/>
    <ExpressSimulator />
    <Benefits />
    <OwnSuccessStories :projects="successList">
      <template v-slot:title>
        Descubre qué han logrado <br> otras <span class="bold">empresas</span>.
      </template>
    </OwnSuccessStories>
    <HowItWorks />
    <Requirements />
    <Teams :logo="'negocios.png'">
      <template v-slot:title>¿Promueves negocios <span class="bold">sostenibles</span>?</template>
      <template v-slot:text>Formemos una alianza para facilitar <br> el financiamiento sostenible en México.</template>
    </Teams>
  </div>
</template>
  
<script>
import sal from 'sal.js'
import FundDestinations from '@components/landing-components/for-business-components/FundDestinations.vue';
import CoinsBanner from '@components/landing-components/for-business-components/CoinsBanner.vue';
import LoanDetail from '@components/landing-components/for-business-components/LoanDetail.vue';
import Benefits from '@components/landing-components/for-business-components/Benefits.vue';
import OwnSuccessStories from '@components/landing-components/for-business-components/OwnSuccessStories.vue';
import HowItWorks from '@components/landing-components/for-business-components/HowItWorks.vue';
import Requirements from '../../components/landing-components/for-business-components/Requirements.vue';
import Teams from '../../components/landing-components/for-business-components/Teams.vue';
import successCard from '../../components/landing-components/partials/success-card.vue';
import ExpressSimulator from '../../components/landing-components/loan-simulator/ExpressSimulator.vue';
export default {
  name: "HomePage",
  components: {
    CoinsBanner,
    FundDestinations,
    LoanDetail,
    Benefits,
    OwnSuccessStories,
    HowItWorks,
    Requirements,
    Teams,
    successCard,
    ExpressSimulator
  },
  mounted() {
    sal();
  },
  data() {
    return {
      successList: [
        {
          alias: "Alvah Energy",
          photo: "alvah-energy.jpg",
          item_list: [
            { title: "Impacto ambiental", value: "" },
            { title: "Fuente de emisión:", value: "Energía" },
            { title: "Línea de acción:", value: "Integración solar" },
            { title: "Beneficio:", value: "1320KW instalados/año" },
            { title: "Monto:", value: "$2,500,000.00" },
            { title: "Estado:", value: "Nuevo León" },
            { title: "Inversionistas:", value: "1191" },
          ]
        },
        {
          alias: "Café Capitán",
          photo: "cafe-capitan.png",
          item_list: [
            { title: "Impacto ambiental", value: "" },
            { title: "Fuente de emisión:", value: "Agronegocios" },
            { title: "Línea de acción:", value: "Agricultura regenerativa" },
            { title: "Beneficio:", value: "14,000 Ha conservadas" },
            { title: "Monto:", value: "$2,732,000.00" },
            { title: "Estado:", value: "Chiapas" },
            { title: "Inversionistas:", value: "1432" },
          ]
        },
        {
          alias: "Desplastifícate",
          photo: "desplastificate.png",
          item_list: [
            { title: "Impacto ambiental", value: "" },
            { title: "Fuente de emisión:", value: "Residuos" },
            { title: "Línea de acción:", value: "Economía circular" },
            { title: "Beneficio:", value: "Kg evitado/año" },
            { title: "Monto:", value: "$1,069,600.00" },
            { title: "Estado:", value: "CDMX" },
            { title: "Inversionistas:", value: "639" },
          ]
        },
      ]
    }
  }
}
</script>
  
<style scoped></style>